import gql from 'graphql-tag'
import moment from "moment"
import { UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, Button, UncontrolledTooltip, Badge, Modal, ModalHeader, ModalBody, Input } from "reactstrap"
import { Component } from 'react'
import { Link } from 'react-router-dom'
import { graphql } from '@apollo/client/react/hoc'
import { UserQuery } from '../Functions/querys'
import NotificationsModal from '../Material/NotificationsModal'
import TodoList from '../Material/TodoList'
import { getToken, onMessageListener } from '../Components/firebase'
import Clock from './Clock'
import withApolloClient from '../withApolloClient'
import NotificationStack from '../Material/NotificationStack.js'
import TimeZoneSelectionPopover from "../User/TimeZoneSelectionPopover"
import BranchSelectionPopover from "./BranchSelectionPopover"
import GlobalNewTaskButton from "./GlobalNewTaskButton"
import { GlobalSearchModal } from "./GlobalSearch"
import { PreferredDateTimeContext } from '../Context/PreferredDateTimeContext'
import '../App.css'


const PendingAuditLogsCountQuery = gql`
    query PendingAuditLogsCountQuery{
        pendingAuditLogsCount
}`

const UpdateMember = gql`
    mutation updateMember($input: UpdateMemberMutationInput!){
        updateMember(input:$input){
        ok
        errors{
            messages
            field
        }
    }
}`

const CreateDevice = gql`
    mutation createDevice($input: CreateDeviceMutationInput!){
        createDevice(input:$input){
        ok
        errors{
            messages
            field
        }
    }
}`

class Header extends Component {
    static contextType = PreferredDateTimeContext;
    searchOpenTimeout = null;
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            showLeftNav: true,
            newNotification: "",
            fireBaseTokenFound: "",
            notification: {},
            loading: false,
            memberId: "",
            headerSearchQuery: "",
            isHeaderSearchFocused: false,
            isGlobalSearchDismissed: false,
            preferredDateTimeInfo: {
                dateFormat: "MMM D, YYYY",
                timeFormat: "h:mm A",
                timezone: "America/New_York"

            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps?.currentUser?.id !== this.props?.currentUser?.id) {
            getToken((token) => {
                this.setState({ fireBaseTokenFound: token })
                if (token) {
                    this.props.apolloClient.mutate({
                        mutation: CreateDevice,
                        variables: { input: { deviceToken: token, name: "bos", deviceType: "web" } },
                    }).then((result) => {
                        if (result.data && result.data.createDevice && result.data.createDevice.ok) {
                        }
                    }).catch((error) => {
                    })
                }
            }
            )
        }
        try {
            onMessageListener(payload => {
                if (payload && payload.notification) {
                    this.setState({ newNotification: payload.notification })
                    this.props.apolloClient?.refetchQueries({ include: [UserQuery] })
                }
            })
        } catch (err) {
            console.log('failed to receive message', err)
        }
        if (
            this.props.currentUser?.member &&
            (
                prevProps.currentUser?.member?.preferredTimeFormat !== this.props.currentUser.member.preferredTimeFormat ||
                prevProps.currentUser?.member?.preferredTimezone !== this.props.currentUser.member.preferredTimezone ||
                prevProps.currentUser?.member?.preferredDateFormat !== this.props.currentUser.member.preferredDateFormat
            )
        ) {
            const preferredDateTimeInfo = {
                timeFormat: this.props.currentUser.member.preferredTimeFormat || this.state.preferredDateTimeInfo.timeFormat,
                timezone: this.props.currentUser.member.preferredTimezone || this.state.preferredDateTimeInfo.timezone,
                dateFormat: this.props.currentUser.member.preferredDateFormat || this.state.preferredDateTimeInfo.dateFormat,
            }
            this.setState({ preferredDateTimeInfo })
        }

    }

    componentWillUnmount() {
        if (this.searchOpenTimeout) {
            clearTimeout(this.searchOpenTimeout)
        }
    }

    toggleModal = (modalName) => {
        if (this.state.openModal !== modalName) {
            this.setState({
                openModal: modalName,
                isGlobalSearchDismissed: modalName === "GlobalSearch" ? false : this.state.isGlobalSearchDismissed,
            })
        } else {
            this.setState({
                openModal: "",
                isGlobalSearchDismissed: modalName === "GlobalSearch" ? true : this.state.isGlobalSearchDismissed,
            })
        }
    }

    isGlobalSearchReady = () => Boolean(this.props.searchToken && this.props.searchHost && this.props.searchIndexes?.length)

    handleHeaderSearchChange = (event) => {
        const headerSearchQuery = event.target.value
        const trimmedQuery = headerSearchQuery.trim()

        if (this.searchOpenTimeout) {
            clearTimeout(this.searchOpenTimeout)
        }

        this.setState({
            headerSearchQuery,
            isGlobalSearchDismissed: false,
        })

        if (!this.isGlobalSearchReady()) return

        if (trimmedQuery.length < 2) {
            if (this.state.openModal === "GlobalSearch") {
                this.setState({ openModal: "" })
            }
            return
        }

        this.searchOpenTimeout = setTimeout(() => {
            this.setState({ openModal: "GlobalSearch" })
        }, 360)
    }

    handleHeaderSearchFocus = () => {
        this.setState({ isHeaderSearchFocused: true })
        if (!this.isGlobalSearchReady()) return
        if (this.state.headerSearchQuery.trim().length < 2) return
        if (this.state.isGlobalSearchDismissed) return
        if (this.searchOpenTimeout) {
            clearTimeout(this.searchOpenTimeout)
        }
        this.searchOpenTimeout = setTimeout(() => {
            this.setState({ openModal: "GlobalSearch" })
        }, 180)
    }

    clearHeaderSearch = () => {
        if (this.searchOpenTimeout) {
            clearTimeout(this.searchOpenTimeout)
        }
        this.setState({
            headerSearchQuery: "",
            openModal: this.state.openModal === "GlobalSearch" ? "" : this.state.openModal,
            isGlobalSearchDismissed: false,
        })
    }

    closeGlobalSearch = () => {
        if (this.searchOpenTimeout) {
            clearTimeout(this.searchOpenTimeout)
        }
        this.setState({ openModal: "", isGlobalSearchDismissed: true })
    }

    updateSelectedInfo = (memberId, name, value) => {
        try {
            const { setPreferredDateTimeInfo } = this.context
            this.setState({ loading: true })
            let input = { memberId, [name]: value }

            this.props.apolloClient.mutate({
                mutation: UpdateMember,
                variables: { input },
            }).then((result) => {
                this.setState({ loading: false })
                if (result.data && result.data.updateMember && result.data.updateMember.ok) {
                    this.props.refetchUserQuery()
                    if (name === 'preferredTimezone') {
                        setPreferredDateTimeInfo('timezone', value)
                    }
                    this.props.setKeyVersion(this.props.keyVersion + 1)
                } else {
                    this.setState({ loading: false })
                }
            }).catch((error) => {
                let errorMessage = "An error has occurred"
                this.setState({ error: errorMessage, loading: false })
            })
        } catch (err) {
            let errorMessage = "An error has occurred"
            this.setState({ error: errorMessage, loading: false })
        }
    };

    renderSelectedBranchesValues = (selectedBranches) => {
        let maxValues = 1
        let hiddenCount = selectedBranches.length - maxValues
        let value = selectedBranches.filter((_, ii) => ii < maxValues).map(item => item.node.name).join(" | ")
        if (hiddenCount > 0) {
            return <span>
                {value}&nbsp;&nbsp;&nbsp;
                <small>+{hiddenCount} More Branch{hiddenCount > 1 ? "es" : ""}</small>
            </span>
        }
        return value
    }

    render() {
        const { loading, currentUser, currentUserLoading, pendingAuditLogsCount } = this.props
        if (loading || currentUserLoading) return null
        if (!currentUser) return null
        const isGlobalSearchReady = this.isGlobalSearchReady()

        return (
            <div className="mainHeader">
                {this.state.openModal === "NotificationsModal" && <NotificationsModal handleClose={() => { this.toggleModal(""); this.props.refetchUserQuery() }} refetchUserQuery={this.props.refetchUserQuery} currentUser={currentUser} open={this.state.openModal === "NotificationsModal"} />}
                {this.state.openModal === "TodoList" && <TodoList handleClose={() => this.toggleModal("")} currentUser={currentUser} open={this.state.openModal === "TodoList"} />}
                <GlobalSearchModal isOpen={this.state.openModal === "GlobalSearch"} toggle={this.closeGlobalSearch} searchToken={this.props.searchToken} searchUrl={this.props.searchHost} indexes={this.props.searchIndexes} initialQuery={this.state.headerSearchQuery} />
                <NotificationStack notification={this.state.newNotification} />

                {!this.state.showLeftNav && <Link to="#" style={{ position: "fixed", left: "13px", top: "47vh", color: "#007bff" }} onClick={() => this.setState({ showLeftNav: true })}><i className={`fa fa-2x fa-chevron-right`} aria-hidden="true" /></Link>}
                <div className="header-toolbar">
                    <p className="header-greetings">Hey <a className="bos-custom-link" style={{ fontWeight: 400 }} href="/user/">{currentUser && currentUser.username && currentUser.username}</a> 👋, its {" "}
                        <Clock key={String(this.props.keyVersion)} />
                    </p>
                    <ButtonGroup className="float-right" >
                        <div className={`header-search-shell ${this.state.openModal === "GlobalSearch" ? "is-active" : ""} ${!isGlobalSearchReady ? "is-loading" : ""}`}>
                            <span className="header-search-shell-icon">
                                <i className={`fa ${isGlobalSearchReady ? "fa-search" : "fa-spinner fa-spin"}`} />
                            </span>
                            <input
                                type="text"
                                className="header-search-input"
                                value={this.state.headerSearchQuery}
                                onChange={this.handleHeaderSearchChange}
                                onFocus={this.handleHeaderSearchFocus}
                                onBlur={() => this.setState({ isHeaderSearchFocused: false })}
                                disabled={!isGlobalSearchReady}
                                autoComplete="off"
                                placeholder={
                                    !isGlobalSearchReady
                                        ? "Search is loading..."
                                        : this.state.isHeaderSearchFocused
                                            ? "Search drivers, cars, conversations, tasks..."
                                            : "Search..."
                                }
                            />
                            {this.state.headerSearchQuery && (
                                <button type="button" className="header-search-clear" onClick={this.clearHeaderSearch} aria-label="Clear search">
                                    <i className="fa fa-times-circle" aria-hidden="true" />
                                </button>
                            )}
                        </div>
                        <GlobalNewTaskButton />
                        {currentUser?.member && this.state.openModal === "branchSelectionPopover" &&
                            <BranchSelectionPopover
                                target="bos-branch-dropdown"
                                open={this.state.openModal === "branchSelectionPopover"} handleClose={() => this.toggleModal("")}
                                userBranches={currentUser.member.branches.edges.sort((a, b) => (a.node.name > b.node.name) ? 1 : -1)}
                                selectedBranches={currentUser.member.selectedBranches.edges.map(branch => branch.node.id)}
                                updateSelectedBranches={(branchIds) => this.updateSelectedInfo(currentUser.member.id, 'selectedBranches', branchIds)}
                            />}
                        <Button color="light" id="bos-branch-dropdown" onClick={() => this.toggleModal("branchSelectionPopover")} disabled={currentUserLoading || this.state.loading} >
                            {!currentUserLoading && currentUser?.member ? <i className={"fa fa-code-fork"} /> : <i className={"fa fa-spinner fa-spin"} />}
                            &nbsp;<sup><Badge className="bos-badge-small" color="primary">{!currentUserLoading && currentUser?.member ? (currentUser.member.selectedBranches.edges?.length) : (currentUser?.member ? "Updating..." : "Loading...")}</Badge></sup>
                        </Button>
                        <UncontrolledTooltip target="bos-branch-dropdown">{!currentUserLoading && currentUser?.member ? "Branch Selection" : currentUser?.member ? "Updating..." : "Loading..."}</UncontrolledTooltip>
                        <Button id="Notifications" color="light" onClick={() => this.toggleModal("NotificationsModal")}> <i className={"fa fa-bell-o"} /> <sup><Badge className="bos-badge-small" color="danger">{currentUser?.unreadNotificationsCount && currentUser.unreadNotificationsCount > 0 ? `${currentUser.unreadNotificationsCount}` : ""}</Badge></sup></Button>
                        <UncontrolledTooltip target="Notifications">Notifications</UncontrolledTooltip>
                        <Button id="AuditLogs" color="light" >
                            <a href="/auditlog">
                                <i className={"fa fa-book"} />
                                &nbsp;<sup><Badge className="bos-badge-small" color="warning">{pendingAuditLogsCount ? `${pendingAuditLogsCount}` : ""}</Badge></sup>
                            </a>
                        </Button>
                        <UncontrolledTooltip target="AuditLogs">Audit Logs</UncontrolledTooltip>
                        <Button id="preferredTimeZone" color="light" onClick={() => this.toggleModal("timezoneSelectionPopover")}>
                            <i className={"fa fa-clock-o"} style={{ color: "#525f7f" }} />
                            &nbsp;<sup><Badge color="primary" className="bos-badge-small">
                                {!currentUserLoading && currentUser?.member ? (this.state.preferredDateTimeInfo.timezone ? <span>{moment.tz(this.state.preferredDateTimeInfo.timezone).format('z')}</span> : "No Timezone Selected!") : (currentUser?.member ? "Updating Timezone..." : "Loading Timezone...")}
                            </Badge></sup>
                        </Button>
                        <UncontrolledTooltip target="preferredTimeZone">Preferred Timezone</UncontrolledTooltip>
                        {currentUser?.member && this.state.openModal === "timezoneSelectionPopover" &&
                            <TimeZoneSelectionPopover
                                target="preferredTimeZone"
                                open={this.state.openModal === "timezoneSelectionPopover"}
                                handleClose={() => this.toggleModal("")}
                                updateSelectedTimezone={(timezone) => this.updateSelectedInfo(currentUser.member.id, 'preferredTimezone', timezone)}
                            />
                        }
                        <UncontrolledDropdown isOpen={this.state.userMenu} toggle={() => this.setState({ userMenu: !this.state.userMenu })}>
                            <DropdownToggle color="light">
                                <i className={"fa fa-user-circle-o"} style={{ color: "#525f7f" }} />
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem tag="a" href="/"> <i className={"fa fa-home"} />&nbsp;&nbsp;Home</DropdownItem>
                                <DropdownItem tag="a" href="/user/" target="_blank"> <i className={"fa fa-user"} />&nbsp;&nbsp;Account Info</DropdownItem>
                                <DropdownItem tag="a" href="/logout/?next=/"> <i className={"fa fa-sign-out"} />&nbsp;&nbsp;Logout</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </ButtonGroup>
                </div>
            </div>
        )
    }
}


//-----------------------------------

export default graphql(UserQuery, {
    props: ({ data: { currentUser, refetch, loading } }) => ({
        currentUser,
        currentUserLoading: loading,
        refetchUserQuery: () => {
            return refetch({
                query: UserQuery,
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { currentUser: fetchMoreResult.currentUser }
                }
            })
        }
    })
})(
    graphql(PendingAuditLogsCountQuery, {
        props: ({ data: { pendingAuditLogsCount } }) => ({
            pendingAuditLogsCount
        })
    })(withApolloClient(Header))
)
